export const connectionIdHeaderName = 'C-WS-ConnectionId';
